import { clearLegacyToken } from './api';

// Before PIN-320 the landing handed the session over as "#token=…". Tokens are
// no longer stored client-side (the session is an httpOnly cookie), so an old
// link's token is only stripped from the address bar, and any token left in
// localStorage from that era is deleted (PIN-336).
export function consumeHashToken() {
  if (typeof window === 'undefined') return;
  clearLegacyToken();
  const hash = window.location.hash.slice(1);
  if (!hash) return;
  const params = new URLSearchParams(hash);
  if (!params.get('token')) return;
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
